import moment from "moment";

export interface CsvRow {
  client_name?: string | null;
  contact_information?: string | null;
  session_type?: string | null;
  participant_count?: number | null;
  date?: string | null;
  session_length?: string | null;
  paid_hours?: string | number | null;
  pro_bono_hours?: string | number | null;
}

export const generateCsv = (
  sessionList: any[]
): { headers: any[]; data: CsvRow[] } => {
  let totalPaidHours = 0;
  let totalProBonoHours = 0;

  const csvListData: CsvRow[] = sessionList.map((session) => {
    const startTime = moment(session.session_start_time, "YYYY-MM-DD HH:mm:ss");
    const endTime = moment(session.session_end_time, "YYYY-MM-DD HH:mm:ss");
    const clientList = session.participant_list.filter(
      (participant: any) => participant.is_creator !== 1
    );

    const clientName = clientList
      .map((client: any) => `${client.first_name} ${client.last_name}`)
      .join(", ");

    const clientEmail = clientList
      .map((client: any) => client.email)
      .join(", ");

    const durationMinutes =
      endTime.diff(startTime, "minutes") >= 0
        ? endTime.diff(startTime, "minutes")
        : 0;
    const durationHours = durationMinutes / 60;

    const paidHours =
      Number(session.amount) > 0 && session.amount !== "None"
        ? durationHours
        : 0;

    const proBonoHours =
      Number(session.amount) <= 0 || session.amount === "None"
        ? durationHours
        : 0;

    totalPaidHours += paidHours;
    totalProBonoHours += proBonoHours;

    return {
      client_name: clientName,
      contact_information: clientEmail,
      session_type:
        session.participant_list.length > 2 ? "Group" : "Individual",
      participant_count: session.participant_list.length - 1,
      date: startTime.format("YYYY-MM-DD"),
      session_length: durationHours.toFixed(2),
      paid_hours: paidHours.toFixed(2),
      pro_bono_hours: proBonoHours.toFixed(2),
    };
  });

  csvListData.push({
    client_name: "Total Hours",
    contact_information: "",
    session_type: "",
    participant_count: null,
    date: "",
    session_length: null,
    paid_hours: totalPaidHours.toFixed(2),
    pro_bono_hours: totalProBonoHours.toFixed(2),
  });

  const csvHeaders = [
    { label: "Client Name", key: "client_name" },
    { label: "Contact Information", key: "contact_information" },
    { label: "Session Type", key: "session_type" },
    { label: "Number of Attendees", key: "participant_count" },
    { label: "Date", key: "date" },
    { label: "Session Length (hours)", key: "session_length" },
    { label: "Paid Hours", key: "paid_hours" },
    { label: "Pro Bono Hours", key: "pro_bono_hours" },
  ];

  return { headers: csvHeaders, data: csvListData };
};
